import Vue from 'vue';

const routes = [
  {
    path: '',
    redirect: { name: 'Establishments' },
  },
  {
    path: '/establishments',
    name: 'Establishments',
    component: () => import('../views/Establishments.vue'),
  },
  {
    path: '/establishment/:establishmentId',
    name: 'Establishment',
    component: () => import('../views/Establishment.vue'),
    props: route => ({ establishmentId: route.params.establishmentId }),
    children: [
      {
        path: 'remove-sheets',
        name: 'RemoveSheets',
        components: { removeSheets: () => import('../components/RouterView.vue') },
        children: [
          {
            path: 'sheets-preview',
            name: 'SheetsPreview',
            component: () => import('../views/establishment/remove-sheets-modal/routes/SheetsPreview.vue'),
          },
          {
            path: 'create-or-merge',
            name: 'CreateOrMerge',
            component: () => import('../views/establishment/remove-sheets-modal/routes/CreateOrMerge.vue'),
          },
          {
            path: 'create',
            name: 'CreateEstablishment',
            component: () => import('../views/establishment/remove-sheets-modal/routes/CreateEstablishment.vue'),
          },
          {
            path: 'target-establishment',
            name: 'TargetEstablishmentChoice',
            component: () => import('../views/establishment/remove-sheets-modal/routes/TargetEstablishmentChoice.vue'),
          },
          {
            path: 'summary',
            name: 'ActionSummary',
            component: () => import('../views/establishment/remove-sheets-modal/routes/ActionSummary.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/authentication',
    name: 'Authentication',
    component: () => import('../views/Authentication.vue'),
  },
];

export default routes;
